module.exports = __webpack_public_path__ + "img/hero-thumb-3.8a0d9a0c.png";